// js
import RollUpOverviewPPTX from '../../../components/analytics/pptx/RollUpOverviewPPTX';
import { connect } from 'react-redux';
import { makeGetTotalSourcesStats, makeGetAllAreasSourcesStats, getActiveAreasWithSubAreasWithSourcesStats } from '../../../selectors/analytics/overviewSelectors';
import { getAbilities } from '../../../selectors/dsa/abilitiesSelectors';


const mapStateToProps = (state, ownProps) => {
  const getTotalSourcesStats = makeGetTotalSourcesStats();
  const getAllAreasSourcesStats = makeGetAllAreasSourcesStats();

  return {
    abilities: getAbilities(state),
    totalStats: getTotalSourcesStats(state, ownProps),
    areaStats: getAllAreasSourcesStats(state, ownProps),
    activeAreasWithSubAreasWithSourcesStats: getActiveAreasWithSubAreasWithSourcesStats(state),
    pptxTarget: 'pptx_roll_up_overview'
  };
};

const mapDispatchToProps = () => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(RollUpOverviewPPTX);



// WEBPACK FOOTER //
// ./src/containers/analytics/pptx/RollUpOverviewPPTX.js